import { HubConnectionBuilder } from '@aspnet/signalr';
import { SignalingChannelBase } from '../webrtc/signaling-channel-base';
import { SignalRFileTransfer } from './signalr-file-transfer';
/**
 * Handles WebRTC signaling messages on the client side.
 */
export class SignalRSignalingChannel extends SignalingChannelBase {
    /**
     *
     * @param signalingUrl The URL of the signaling hub.
     * @param iceServers A collection of ICE servers that can be used for WebRTC.
     * @param groupName The name of the SignalR group. The group name equals the preview session ID.
     * @param isInitiator Indicates whether this client is the initiator of the session.
     * @param supportsDataChannels Indicates whether WebRTC can be used for transferring preview data. Even though the device supports
     * WebRTC, data channel support may still be insuficcient, such as on iOS11/12, see https://github.com/webrtc/samples/issues/1123.
     */
    constructor(eventListener, connectionFactory, signalingUrl, groupName, isInitiator, previewScope, supportsDataChannels, role, instanceId) {
        super(eventListener, connectionFactory, groupName, isInitiator, previewScope, supportsDataChannels, role, instanceId);
        this.type = 'remote';
        let connection = new HubConnectionBuilder()
            .withUrl(signalingUrl)
            // .configureLogging(SignalRLogLevel.Trace)
            .build();
        this.connection = connection;
        connection.on('ReceiveServerSignalingMessage', data => {
            this.handleSignalingMessage(data);
        });
        console.log(`Signaling: starting connection..`);
        connection
            .start()
            .then(() => {
            this.isConnected = true;
            eventListener.onChannelReady(this);
        })
            .catch(reason => {
            console.error("Signaling error", reason);
        });
        connection
            .onclose(async (e) => {
            this.isConnected = false;
        });
    }
    createFileTransferFallback() {
        return new SignalRFileTransfer(this.connection, this.clientId);
    }
    sendSignalingMessage(message) {
        if (!this.isConnected) {
            if (message.type === 5 /* SignalingMessageType.LeaveGroup */)
                return; // don't throw errors if leaving (probably closing the browser)
            throw `Signaling: unable to send signaling message. The client is not connected.`;
        }
        this.connection
            .invoke('ReceiveClientSignalingMessage', message)
            .catch(reason => console.error("SignalR error", reason));
    }
}
//# sourceMappingURL=signalr-signaling-channel.js.map